import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//列表
export async function getSectorList(params) {
    return post(oaserver+'/dict/sector/getSectorList', params, true);
}
//新增
export async function addSector(params) {
    return post(oaserver+'/dict/sector/addSector', params, true);
}
//编辑
export async function editSector(params) {
    return post(oaserver+'/dict/sector/editSector', params, true);
}
